// eslint-disable-next-line no-shadow
export enum AuthDictionary {
  ALREADY_HAVE_AN_ACCOUNT = 'Already have an account?',
  LOG_IN_WITH = 'LOG IN WITH',
  SETUP_YOUR_ACCOUNT = 'Setup your account',
  EMAIL_RESENT_SUCCESS = 'Email has been resent successfully.',
}
